/* eslint-disable react/forbid-prop-types */
import React, { Component } from 'react';
import { ComboBox, DropdownSkeleton } from 'carbon-components-react';
import PropTypes from 'prop-types';
import { api } from '../../../helpers/api/api';

export default class InspectionTypeComboBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      items: []
    };
    this.onChange = this.onChange.bind(this);
  }

  async componentDidMount() {
    if (!this.props.section && this.props.loadAll === false) return;
    this.setState({ loading: true });
    const items = await this.getItems();
    this.setState({ items, loading: false });
  }

  onChange = (selectedItem) => {
    const item = selectedItem ? selectedItem.selectedItem : null;
    this.props.onChange(item);
  };
  

  getInspectionType = async (section) => {
    const types = (await api.getAll('/inspection/types')).data;
    if (section) return types.filter((w) => w.idInspectionSection === section);
    return types;
  };


  getItems = async () => {
    let items = [];
    try {
      items = this.props.loadAll
        ? await this.getInspectionType()
        : await this.getInspectionType(this.props.section);

      if (this.props.loadAll) {
        const map = new Map();
        const result = [];
        items.map((item) => {
          if (!map.has(item.name)) {
            map.set(item.name, true);
            result.push({ name: item.name });
          }
          return null;
        });
        items = result;
      }
    } catch (error) {
      this.props.onError(error);
    }
    return items;
  };

  render() {
    return this.state.loading ? (
      <DropdownSkeleton />
    ) : (
      <ComboBox
        id="comboBoxInspectionType"
        invalid={this.props.invalid}
        invalidText={this.props.invalidText}
        disabled={this.state.items<1}
        placeholder="Choose a Type"
        items={this.state.items}
        onChange={this.onChange}
        shouldFilterItem={({ item, inputValue }) =>
          item.name?.toLowerCase().includes(inputValue?.toLowerCase()) ||
          item.code?.toLowerCase().includes(inputValue?.toLowerCase())
        }
        itemToString={(item) => (item ? item && item.name : '')}
        initialSelectedItem={this.props.initialSelectedItem}
      />
    );
  }
}

InspectionTypeComboBox.propTypes = {
  invalid: PropTypes.bool,
  invalidText: PropTypes.string,
  section: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  loadAll: PropTypes.bool,
  initialSelectedItem: PropTypes.object,
  disabled: PropTypes.bool
};
InspectionTypeComboBox.defaultProps = {
  invalid: false,
  invalidText: '',
  section: null,
  loadAll: false,
  initialSelectedItem: null,
  disabled: true
};
